import CourseDetailLayout from '../components/CourseDetailLayout'
import { getSchedule } from '../components/ScheduleTable'
import { useTranslation } from 'react-i18next'
import modernMobile01 from '../assets/courses/mobile/modern-01.jpg'
import modernMobile02 from '../assets/courses/mobile/modern-02.jpg'
import modernMobile03 from '../assets/courses/mobile/modern-03.jpg'
import modernMobile04 from '../assets/courses/mobile/modern-04.jpg'
import modernDesktop01 from '../assets/courses/desktop/modern-01.jpg'
import modernDesktop02 from '../assets/courses/desktop/modern-02.jpg'
import modernDesktop03 from '../assets/courses/desktop/modern-03.jpg'
import modernDesktop04 from '../assets/courses/desktop/modern-04.jpg'

const mobilePics = [modernMobile01, modernMobile02, modernMobile03, modernMobile04]
const desktopPics = [modernDesktop01, modernDesktop02, modernDesktop03, modernDesktop04]

const classes = getSchedule('schedule.modernBallet')

const ModernPage = () => {
  const { t } = useTranslation()

  return (
    <CourseDetailLayout
      title={t('nav.modern')}
      images={mobilePics}
      desktopImages={desktopPics}
      content={[t('courses.modernDescription'), t('courses.modernDetails')]}
      classes={classes}
    />
  )
}

export default ModernPage
